import * as React from "react";
import * as ReactDOM from "react-dom";

export const GUIDE_HIGHLIGHT_COLOR = "#f59e0b";

interface Props {
  selector: string;
  padding?: number;
  borderRadius?: number;
}

export const GuideIndicator: React.FC<Props> = ({ selector, padding = 4, borderRadius = 4 }) => {
  const [rect, setRect] = React.useState<DOMRect | null>(null);

  React.useEffect(() => {
    const updatePosition = () => {
      const element = document.querySelector(selector);
      if (element) {
        setRect(element.getBoundingClientRect());
      } else {
        setRect(null);
      }
    };

    updatePosition();

    const resizeObserver = new ResizeObserver(updatePosition);
    const element = document.querySelector(selector);
    if (element) {
      resizeObserver.observe(element);
    }

    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    const intervalId = setInterval(updatePosition, 500);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
      clearInterval(intervalId);
    };
  }, [selector]);

  if (!rect) {
    return null;
  }

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: rect.top - padding,
        left: rect.left - padding,
        width: rect.width + padding * 2,
        height: rect.height + padding * 2,
        borderRadius: borderRadius,
        border: `2px solid ${GUIDE_HIGHLIGHT_COLOR}`,
        boxShadow: `0 0 0 4px rgba(245, 158, 11, 0.3), 0 0 20px rgba(245, 158, 11, 0.4)`,
        pointerEvents: "none",
        zIndex: 10001,
        animation: "guideIndicatorPulse 2s ease-in-out infinite",
      }}
    />,
    document.getElementById("guide")!,
  );
};
